import { ActionButton } from "./ActionButton";
import { TechCheckIcon } from "./icons/TechCheckIcon";
import { useAppStateContext } from "hooks/useAppState/useAppState";
import useVideoContext from "hooks/livekit/useVideoContext/useVideoContext";

export const ToggleSettingsModalButton = () => {
  const {
    modal: { openDeviceSettingsModal },
  } = useAppStateContext();
  const { localTracks } = useVideoContext();

  const hasAudioTrack = localTracks.some((track) => track.kind === "audio");
  const hasError = !hasAudioTrack;

  return (
    <ActionButton
      tooltip={"Audio Settings"}
      onClick={openDeviceSettingsModal}
      badge={hasError ? "!" : null}
    >
      <TechCheckIcon />
    </ActionButton>
  );
};
